import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const RoleBaseDesign = React.lazy(() => import('.'));

export const roleBaseDesignRoutes = [
  new Route({
    path: 'role-base-design',
    element: RoleBaseDesign,
    children: [],
  }),
];
